// src/services/tagService.js
import { apiRequest } from './apiService';

const tagService = {
  // 獲取標籤列表
  getTags: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.includeInactive) {
        queryParams.append('includeInactive', 'true');
      }
      if (params.search) {
        queryParams.append('search', params.search);
      }
      if (params.limit) {
        queryParams.append('limit', params.limit);
      }
      if (params.offset) {
        queryParams.append('offset', params.offset);
      }
      
      const endpoint = `tags${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await apiRequest('get', endpoint);
      
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || '獲取標籤列表時發生錯誤');
    }
  },
  
  // 獲取單個標籤
  getTagById: async (id) => {
    try {
      const response = await apiRequest('get', `tags/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || '獲取標籤時發生錯誤');
    }
  },
  
  // 創建標籤
  createTag: async (tagData) => {
    try {
      const response = await apiRequest('post', 'tags', tagData);
      
      // Handle both direct data and success/data structure
      if (response.data && response.data.success) {
        return response.data;
      }
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('創建標籤時發生錯誤');
    }
  },
  
  // 更新標籤
  updateTag: async (id, tagData) => {
    try {
      const response = await apiRequest('put', `tags/${id}`, tagData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || '更新標籤時發生錯誤');
    }
  },
  
  // 刪除標籤
  deleteTag: async (id) => {
    try {
      const response = await apiRequest('delete', `tags/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || '刪除標籤時發生錯誤');
    }
  },
  
  // 停用標籤
  deactivateTag: async (id) => {
    try {
      const response = await apiRequest('put', `tags/${id}/deactivate`, {});
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || '停用標籤時發生錯誤');
    }
  },
  
  // 啟用標籤
  activateTag: async (id) => {
    try {
      const response = await apiRequest('put', `tags/${id}/activate`, {});
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || '啟用標籤時發生錯誤');
    }
  },
  
  // 獲取標籤統計
  getTagStats: async () => {
    try {
      const response = await apiRequest('get', 'tags/stats');
      
      // Handle both direct data and success/data structure
      if (response.data && response.data.success && response.data.data) {
        return response.data.data;
      }
      return response.data;
    } catch (error) {
      // Return empty stats on error to prevent crashes
      return { total: 0, active: 0, inactive: 0 };
    }
  },
  
  // 批量創建標籤
  batchCreateTags: async (tags) => {
    try {
      const response = await apiRequest('post', 'tags/batch', { tags });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || '批量創建標籤時發生錯誤');
    }
  }
};

export default tagService;